<template>
  <div class="form-data-box" v-loader.opacity.tab="loading">
    <div class="alert" :class="alert.class" role="alert" v-if="alert.message">
      <span v-html="alert.message"></span>
      <button type="button" class="btn-close" aria-label="Close" @click="alert.message = null"></button>
    </div>

    <div class="row justify-content-md-start" v-if="userData.id">
      <div class="col-md-4">
      </div>

      <div class="col-md-8 offset-md-4 scrollbar">
        <section>
          <div class="form-floating">
            <input type="text" class="form-control" name="userData[firstName]" ref="firstName" id="firstName"
                   v-model="userData.collaborator.firstName" :placeholder="$t('user.firstName')" data-test="inputUserFirstName" :disabled="!isCurrentUser">
            <label for="firstName">{{ $t('user.firstName') }}</label>
          </div>
          <div class="form-floating">
            <input type="text" class="form-control" id="lastName" name="userData[lastName]" v-model="userData.collaborator.lastName" data-test="inputUserLastName" :placeholder="$t('user.lastName')" :disabled="!isCurrentUser">
            <label for="lastName">{{ $t('user.lastName') }}</label>
          </div>
          <div class="form-floating">
            <input type="text" class="form-control" id="email" name="userData[email]" v-model="userData.email" disabled data-test="inputUserEmail" :placeholder="$t('user.email')">
            <label for="email">{{ $t('user.email') }}</label>
          </div>
          <div class="form-floating">
            <input type="text" class="form-control" name="userData[collaborator.telephone1]" ref="telephone1" id="telephone1"
                   v-model="userData.collaborator.telephone1" :placeholder="$t('user.collaborator.telephone1')" data-test="inputtelephone1" :disabled="!isCurrentUser">
            <label for="telephone1">{{ $t('user.telephone1') }}</label>
          </div>
          <div class="form-floating">
            <input type="text" class="form-control" id="npi" name="userData[npi]" v-model="userData.collaborator.npi" data-test="inputUserNpi" :placeholder="$t('user.npi')">
            <label for="npi">{{ $t('user.npi') }}</label>
          </div>
          <div class="form-floating">
            <input type="text" class="form-control" id="document" name="userData[document]" v-model="userData.collaborator.document" data-test="inputUserDocument" :placeholder="$t('user.document')">
            <label for="document">{{ $t('user.document') }}</label>
          </div>
          <div class="form-floating">
            <input type="text" class="form-control" id="permissions" name="userData[permissions]" :value="$t(`${userData.permissions}`)" data-test="inputUserPermissions" :placeholder="$t('user.permissions')" disabled>
            <label for="permissions">{{ $t('user.permissions') }}</label>
          </div>
          <div class="form-check disabled">
            <BaseSquareCheckBox :checkbox_id="'mfa'" :item="'mfa'" @checked=""/>
            <label class="form-check-label" for="mfa">
              {{ $t('user.mfa') }}
            </label>
          </div>
        </section>
      </div>

      <div class="action-bar" v-if="userData.id">
        <button class="btn btn-success" type="button" name="button" data-test="btnUpdate" v-if="hasFormChanged && isCurrentUser" @click="doUpdate">
          <span>{{ $t('user.modify') }}</span>
        </button>
        <button class="btn btn-secondary" type="button" name="button" data-test="btnOpenModalSignature" @click="openSignatureModal()" v-if="isCurrentUser">
          <span>{{ $t('user.signature') }}</span>
        </button>
        <button class="btn btn-secondary" type="button" name="button" data-test="btnOpenModalPhoto" @click="openChangePhotoModal()" v-if="isCurrentUser && false">
          <span>{{ $t('user.changePhoto') }}</span>
        </button>
        <button class="btn btn-secondary" type="button" name="button" data-test="btnOpenModalPassword" @click="openChangePassword()" v-if="isCurrentUser">
          <span>{{ $t('user.changePassword') }}</span>
        </button>
        <button class="btn btn-secondary" type="button" name="button" data-test="btnOpenModalPin" @click="openChangePin()" v-if="isCurrentUser">
          <span>{{ $t('user.changePIN') }}</span>
        </button>
        <button id="changePermission" type="button" class="btn btn-secondary" @click="openModalPermissions" data-test="btnOpenModalPermissions" v-if="session.isPowerfull && !isCurrentUser">
          {{ $t('user.changePermission') }}
        </button>
        <button class="btn btn-secondary" type="button" data-test="btnMfaSetup" @click="mfaSetup()" v-if="isCurrentUser">
          {{ $t('user.mfaSetup') }}
        </button>
        <button class="btn btn-outline-danger" type="button" data-test="btnMfaSetup" @click="openModalDelete(userData.id)" v-if="session.isPowerfull && !isCurrentUser">
          {{ $t('remove') }}
        </button>
      </div>
    </div>

    <UserChangePinOffcanvas :offcanvas_id="'userChangePin'" ref="userChangePinOffcanvas"/>

    <UserChangePasswordOffcanvas :offcanvas_id="'userChangePassword'" ref="userChangePasswordOffcanvas"/>

    <UserPermissionsOffcanvas :offcanvas_id="'userPermissionsOffcanvas'" :user="userData" ref="userPermissionsOffcanvas"/>

    <BaseCropperOffcanvas :offcanvas_id="'userData'" ref="offcanvasCropper"/>

    <BaseGenericOffcanvas :offcanvas_id="'offcanvasGeneric'" ref="offcanvasGeneric"/>
  </div>
</template>

<style lang="scss" scoped>
.col-md-8 {
  min-height:                        calc(100vh - 309px);
  max-height:                        calc(100vh - 328px);
}

.has-alert {
  .col-md-8 {
    min-height:                      calc(100vh - 380px);
    max-height:                      calc(100vh - 396px);
  }
}

#permissions {
  text-transform:                    capitalize !important;
}

@media (max-width: 991px) {
  .sub-title {
    font-size:                       14px;
  }

  .col-md-8 {
    min-height:                      calc(100dvh - 228px) !important;
    max-height:                      calc(100dvh - 228px) !important;
    padding:                         0 24px;
  }

  .has-alert {
    .col-md-8 {
      min-height:                   calc(100dvh - 299px) !important;
      max-height:                   calc(100dvh - 299px) !important;
    }
  }
}

@media (max-width: 1500px) {
  .col-md-8 {
    min-height:                      calc(100vh - 303px);
    max-height:                      calc(100vh - 318px);
  }

  .has-alert {
    .col-md-8 {
      min-height:                    calc(100vh - 374px);
      max-height:                    calc(100vh - 390px);
    }
  }
}
</style>

<script>
import { useUserStore } from '@/store/user'
import UserChangePasswordOffcanvas from './UserChangePasswordOffcanvas.vue'
import UserChangePinOffcanvas from './UserChangePinOffcanvas.vue'
import UserPermissionsOffcanvas from './UserPermissionsOffcanvas.vue'

export default {
  name: 'UserDataTab',
  props: ['user_id', 'alertmsg'],
  components: {
    UserChangePinOffcanvas,
    UserChangePasswordOffcanvas,
    UserPermissionsOffcanvas,
  },
  data: () => ({
    loading: false,
    alert: {
      message: null,
      class: null
    },
    session: {
      collaborator: {},
      currentClinic: {}
    },
    showChangePin: false,
    showModalPermissions: false,
    showModalCropper: false,
    showChangePassword: false,
    disabled: true,
    userData: {
      activeUser: null,
      accessCode: "",
      collaborator: {
        acceptedTerm: {
          accepted: true,
          date: "",
          ip: "",
        },
        countryCode: "",
        createdAt: "",
        currentClinic: "",
        deleted: false,
        document: "",
        email: "",
        firstName: "",
        id: "",
        lastName: "",
        medic: false,
        npi: "",
        photo: "",
        rawName: "",
        signature: "",
        status: "",
        telephone1: "",
        telephone2: "",
        telephone3: "",
        updatedAt: "",
        uuid: "",
      },
      createdAt: "",
      email: null,
      enforceMFA: false,
      id: "",
      mfa: null,
      mfaEnabled: false,
      passwordSecurity: null,
      passwordWasChanged: false,
      patient: null,
      permissions: "",
      updatedAt: "",
      username: "",
      uuid: "",
    },
    photo: null,
    signature: null,
    cropperType: null,
    imageSource: null,
    mfa: {
      email: {},
      mobile: {}
    },
    hasFormChanged: false,
    initialForm: {},
    changedFormItems: [],
  }),
  watch: {
    alertmsg: function(newVal) {
      if (newVal) {
        this.alert.message = newVal.message
        this.alert.class = newVal.class
      } else {
        this.alert.message = null
      }
    },
    user_id: {
      immediate: true,
      handler: function (user_id) {
        if (user_id) {
          this.fetchData()

          this.$nextTick(() => {
            this.hasFormChanged = false
            this.changedFormItems = []
          })
        }
    }, deep: true },
    userData: {
      immediate: true,
      handler: function(newValue) {
        this.checkFormChange(newValue, 'userData')
    }, deep: true},
  },
  computed: {
    isCurrentUser() {
      return this.session.collaborator.uuid === this.userData.uuid
    }
  },
  mounted() {
    const userStore = useUserStore()
    this.session = userStore.sessionInfo

    this.$nextTick(() => {
      this.mfaStatus(this.userData)
    })
  },
  methods: {
    checkFormChange(value, obj) {
      let hasObj = this.changedFormItems.includes(obj)
      if (JSON.stringify(value) === JSON.stringify(this.initialForm[obj])) {
        if (hasObj) {
          let index = this.changedFormItems.indexOf(obj)
          this.changedFormItems.splice(index, 1)
        }

        if (this.changedFormItems.length > 0)
          return

        this.hasFormChanged = false
      } else {
        if (!hasObj)
          this.changedFormItems.push(obj)

        this.hasFormChanged = true
      }
    },
    async fetchData() {
      let params = {
        id: this.user_id,
      }

      this.loading = true
      NProgress.start()
      try {
        let response = await this.$userService.getUser(params);


        this.userData = response.result
        this.photo = this.userData.collaborator.photo ? response.result.collaborator.photo : '/images/phelcom/profile_img.png'
        this.signature = this.userData.collaborator.signature
        const formWrap = {
          userData: this.userData
        }

        this.initialForm = _.cloneDeep(formWrap)
        console.log('initial form', this.initialForm);
      } catch (err) {
        this.$message.popup(this, 'request_error', 'operationFail', 'error')
        // this.alert = this.$message.alert(this, 'request_error', 'danger')
      }
      NProgress.done(true)
      this.loading = false
    },
    mfaStatus(user) {
      let mfaUserStatus = this.$userService.mfaStatus(user)
      if (mfaUserStatus == 'label-danger') {
        // return
      } else {
        document.getElementById('mfa').click()
      }
      // return this.$userService.mfaStatus(user)
    },
    editFields() {
      this.disabled = !this.disabled;
      this.$nextTick(() => {
        this.$refs.firstName.focus()
      })
    },
    doUpdate: async function() {
      this.alert.message = null
      let params = {
        user: this.userData
      }

      params.user.npi = this.userData.collaborator.npi
      params.user.document = this.userData.collaborator.document

      this.loading = true
      NProgress.start()
      try {
        let response = await this.$userService.updateUser(params)
        this.$message.popup(this, 'general.updatedSuccess', 'operationSuccess', 'success')
        this.disabled = !this.disabled
      } catch (err) {
        this.$message.popup(this, 'general.updatedError', 'operationFail', 'error')
        // this.alert = this.$message.alert(this, 'general.updatedError', 'danger')
      }
      NProgress.done(true)
      this.loading = false
    },
    async openSignatureModal() {
      let signatureURL = await this.$userService.getSignature()
      let params = {
        type: "user.changeSignature",
        image: signatureURL.result
      }
      this.openCropperModal(params)
    },
    async openChangePhotoModal() {
      let photoURL = await this.$userService.getPhoto()
      let params = {
        type: "user.changePhoto",
        image: photoURL.result
      }

      this.openCropperModal(params)
    },
    async openChangePin() {
      const ok = await this.$refs.userChangePinOffcanvas.show({
        title: this.$i18n.t('user.changeDevicePIN'),
        // text: text,
        okButton: this.$i18n.t('user.modify'),
        okButtonClass: 'btn-success',
        // cancelButton: this.$i18n.t('termsPatient.doNotAccept'),
        // cancelButtonClass: 'btn-outline-secondary'
      })
      if (ok) {
        console.log('the pin has been changed');
        // this.$router.push({name: 'patient-create', params: {patientID: ''}})
      }
    },
    async openChangePassword() {
      const ok = await this.$refs.userChangePasswordOffcanvas.show({
        title: this.$i18n.t('user.changePassword'),
        // text: text,
        okButton: this.$i18n.t('user.modify'),
        okButtonClass: 'btn-success',
        // cancelButton: this.$i18n.t('termsPatient.doNotAccept'),
        // cancelButtonClass: 'btn-outline-secondary'
      })
      if (ok) {
        console.log('the password has been changed');
        // this.$router.push({name: 'patient-create', params: {patientID: ''}})
      }
    },
    async openCropperModal(params) {
      this.alert.message = null;

      const ok = await this.$refs.offcanvasCropper.show({
        title: this.$i18n.t(params.type),
        imgSrc: params.image,
        aspectRatio: params.type == 'user.changePhoto' ? 0 : null,
        okButton: this.$i18n.t('save'),
        okButtonClass: 'btn-primary',
        removeButton: params.type == 'user.changeSignature' ? true : false,
        cancelButton: this.$i18n.t('cancel'),
        cancelButtonClass: 'btn-outline-secondary'
      })
      if (ok) {
        if (ok.removeSignature) {
          var formData = new FormData();
          formData.append('removeSignature', 'yes');
          this.doSaveCropper(formData, params.type, true);
        } else if (ok.canvas) {
          ok.canvas.toBlob(blob => {
            var formData = new FormData();
            formData.append('data', blob);
            this.doSaveCropper(formData, params.type, false);
          }, 'image/png');
        }
      }
    },
    async openModalPermissions() {
      const ok = await this.$refs.userPermissionsOffcanvas.show({
        title: this.$i18n.t('user.changePermission'),
        // text: text,
        okButton: this.$i18n.t('save'),
        okButtonClass: 'btn-success',
        // cancelButton: this.$i18n.t('termsPatient.doNotAccept'),
        // cancelButtonClass: 'btn-outline-secondary'
      })
      if (ok) {
        console.log('the permission has been change');
        // this.$router.push({name: 'patient-create', params: {patientID: ''}})
      }
    },
    closeModal(values) {
      values.type === 'password' ? this.showChangePassword = false : this.showChangePin = false
      this.setAlert(values.alert)
    },
    closeModalPermissions() {
      this.$nextTick(() => {
        this.showModalPermissions = false

      })
    },
    async doSaveCropper(value, type, removeSignature) {
      let params = {
        id: this.user_id,
        data: value.get('data'),
        removeSignature: removeSignature
      }

      this.loading = true
      NProgress.start()
      try {
        if (type == 'user.changePhoto') {
          this.changePhoto(params)
        } else {
          this.changeSignature(params)
        }
        this.$message.popup(this, 'general.updatedSuccess', 'operationSuccess', 'success')
      } catch (err) {
        this.$message.popup(this, 'general.updatedError', 'operationFail', 'error')
        // this.alert = this.$message.alert(this, 'general.updatedError', 'danger')
      } finally {
        NProgress.done(true);
        this.loading = false;
      }
    },
    async changePhoto(params) {
      let response = await this.$userService.uploadPhoto(params)
      this.imageSource = response.result
      this.emitter.emit("profilePhotoChanged", this.imageSource);
    },
    async changeSignature(params) {
      let response = await this.$userService.uploadSignature(params)
        this.signature = response.result
        this.emitter.emit("signatureChanged", this.imageSource);
    },
    setAlert(value) {
      if (value) {
        this.alert = value
      }
    },
    mfaSetup() {
      this.$router.push(`/user/mfa/${this.user_id}`)
    },
    doDelete: async function(deleteId) {
      this.alert.message = null

      let params = {
        id: deleteId
      }

      this.loading = true
      NProgress.start()
      try {
        let response = await this.$userService.remove(params);
        this.$message.popup(this, 'general.removedSuccess', 'operationSuccess', 'success')
        if (response.forceLogout) {
          window.location = '/logout'
          return
        }

        //this.fetchData()
        this.$router.push({name: 'settings'})

      } catch (err) {
        this.$message.popup(this, 'general.removedError', 'operationFail', 'error')
        // this.alert = this.$message.alert(this, 'general.removedError', 'danger')
      }
      NProgress.done(true)
      this.loading = false
    },
    async openModalDelete(deleteId) {
      const ok = await this.$refs.offcanvasGeneric.show({
        modalType: 'danger',
        title: this.$i18n.t('confirm'),
        text: this.$i18n.t('user.removalConfirmation'),
        okButton: this.$i18n.t('remove'),
        okButtonClass: 'btn-danger',
        // cancelButton: this.$i18n.t('cancel'),
        // cancelButtonClass: 'btn-outline-secondary'
      })
      if (ok) {
        this.doDelete(deleteId)
      }
    },
  }
}
</script>
